import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useParams } from 'react-router-dom';
import LocalizationProvider from './utils/providers/LocalizationProvider'
import { useLocalization } from './utils/hooks/useLocalization';
import { useLocation } from 'react-router-dom';
import Navbar from './components/Navbar/Navbar';
import Footer from './components/Footer/Footer';
import LandingPage from './pages/LandingPage/LandingPage';
import AboutPage from './pages/AboutPage/AboutPage';
import ArtistsPage from './pages/ArtistsPage/ArtistsPage';
import ProductsPage from './pages/ProductsPage/ProductsPage';
import ProductDetailPage from './pages/ProductDetailPage/ProductDetailPage';
import ArtistBioPage from './pages/ArtistBioPage/ArtistBioPage';
import DiscoverPage from './pages/DiscoverPage/DiscoverPage';
import { UrlUtils } from './utils/urlUtils';
import configs from './configs/configs';
import './App.module.css';


function LocalizedDOM({lang, isMobile}) {
  
  console.log("isMobile:", isMobile);
  const { currentLanguage, changeLanguage, getSupportedLanguages } = useLocalization();
  const location = useLocation();
  
   useEffect(() => {
    if (lang != currentLanguage) {
      changeLanguage(lang);
    }
  }, [location]);

  function RedirectArtist() {
    const { artistId } = useParams();
    const lang = "en"; // or retrieve from your context/store/props

    return <Navigate to={`/${lang}/artist/${artistId}`} replace />;
  }
  function RedirectProduct() {
    const { prodId } = useParams();
    const lang = "en"; // or retrieve from your context/store/props

    return <Navigate to={`/${lang}/product/${prodId}`} replace />;
  }

  return (
  <div className="app">
    <Navbar isMobile={isMobile} />
    <main>
      <Routes>
        <Route path="/artist/:artistId" element={<RedirectArtist />} />
        <Route path=":lang?/artist/:artistId" element={<ArtistBioPage isMobile={isMobile} />} />

        <Route path="/product/:prodId" element={<RedirectProduct />} />
        <Route path=":lang/product/:prodId" element={<ProductDetailPage isMobile={isMobile} />} />

        <Route path="/products" element={<Navigate to={`/${lang}/products`} replace />} />
        <Route path=":lang/products" element={<ProductsPage arePreordersOpen={configs.preordersOpen} />} />

        <Route path="/artists" element={<Navigate to={`/${lang}/artists`} replace />} />
        <Route path=":lang/artists" element={<ArtistsPage isMobile={isMobile} />} />

        <Route path="/story" element={<Navigate to={`/${lang}/story`} replace />} />
        <Route path=":lang/story" element={<AboutPage isMobile={isMobile} />} />
        
        <Route path="/discover" element={<Navigate to={`/${lang}/discover`} replace />} />
        <Route path=":lang/discover" element={<DiscoverPage />} />

        <Route path="/home" element={<Navigate to={`/${lang}/home`} replace />} />
        <Route path=":lang/home" element={<LandingPage />} />
        <Route path="/" element={<LandingPage />} />

        {/* Fallback: catch all unmatched routes */}
        <Route path="*" element={<Navigate to={`/${lang}/home`} replace />} />
      </Routes>
    </main>
    <Footer />
  </div>);
}


function App() {
  const lang = UrlUtils.getLanguageFromPath();
  const [width, setWidth] = useState(window.innerWidth);

  function handleWindowSizeChange() {
      setWidth(window.innerWidth);
  }
  
  useEffect(() => {
      window.addEventListener('resize', handleWindowSizeChange);
      return () => {
          window.removeEventListener('resize', handleWindowSizeChange);
      }
  }, []);


  const isMobile = width <= 768;
  return (
    <Router>
      <LocalizationProvider>
        <LocalizedDOM lang={lang} isMobile={isMobile} />
      </LocalizationProvider>
    </Router>
  );
}

export default App;